import { observable } from 'mobx';

import { SerializedData, Store } from 'bernie-core';
import { FlightsImagePlacard, FlightsPlacardType } from 'types/shared';

export class MessagingCardsStore extends Store {
  @observable public messagingCards?: FlightsPlacardType[];
  @observable public separateTicketBanner?: FlightsImagePlacard;

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }
}
MessagingCardsStore.DEFAULTS = {
  messagingCards: []
};
